<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14xAdzB/tc-custom/9780062970596.jpg?1718106102525" alt="This image is the cover for the book Forgotten Letters of Esther Durrant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forgotten Letters of Esther Durrant
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A cache of unsent love letters from the 1950s is found in a suitcase on a remote island in this mysterious love story in the tradition of the novels by </b><b>Kate Morton and Elizabeth Gilbert</b><i><b>.</b></i><b></b><br/><br/>1951. Esther Durrant, a young mother, is committed to an isolated mental asylum by her husband. Run by a pioneering psychiatrist, the hospital is at first Esther’s prison but soon surprisingly becomes her refuge. </p><p>2018. Free-spirited marine scientist Rachel Parker embarks on a research posting in the Isles of Scilly, off the Cornish coast. When a violent storm forces her to take shelter on a far-flung island, she discovers a collection of hidden love letters. Captivated by their passion and tenderness, Rachel determines to track down the intended recipient. But she has no idea of the far-reaching consequences her decision will bring.</p><p>Meanwhile, in London, Eve is helping her grandmother, a renowned mountaineer, write her memoirs. When she is contacted by Rachel, it sets in motion a chain of events that threatens to reveal secrets kept buried for more than sixty years.</p><p>With an arresting dual narrative that immediately captivates the reader, <i>The Forgotten Letters of Esther Durrant </i>is an inspirational story of the sacrifices made for love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kayte Nunn
      </h2>
      
      <p class="authorDescription body article"><P>Kayte Nunn is a former magazine and book editor, and the international bestselling author of four novels, among them <I>The Botanist’s Daughter</I> and <I>The Forgotten Letters of Esther Durrant</I>. Originally from Britain, she has also lived in the USA, and now resides in Australia, in Northern New South Wales, with her family.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ffba285e